import React, { Component } from 'react';
import { NormalButton } from '../components';
import {
  inject,
  observer,
} from 'mobx-react';
import { OUTPUT_TTL } from '../../../constants/Pac';
import Counter, { formatSeconds } from '../../Counter/Counter';
import { DeviceStatus } from '../../../constants/DeviceStatus';
import {
  Sound,
  Sounds,
} from '../../Sound';
import Toggle from 'react-toggle';
import { IconUnitLabel } from '../components/labels';
import {
  AnalogIconList,
  AnalogUnitList,
} from '../../../constants/DeviceModels';
import Button from 'react-bootstrap/lib/Button';

@inject('batchStore', 'devicesStore')
@observer
class ForwardReverseMixer extends Component {

  render() {
    const { device, batchStore, devicesStore } = this.props;
    const isForwardOff = batchStore.isInputPortOff(device.openTiltStatusPNo);
    const isReverseOff = batchStore.isInputPortOff(device.closeReturnStatusPNo);
    const isForwardOutputOff = !batchStore.isOutputOn(device.openTiltPNo);
    const isReverseOutputOff = !batchStore.isOutputOn(device.closeReturnPNo);
    const name = device.description || `F-R Mixer #${device.id}`;
    let mixerDataStatus = batchStore.getDeviceStatus(device.id);
    const error = mixerDataStatus.error ? 'error' : '';
    const countDownOn = mixerDataStatus.status !== DeviceStatus.IDLE && mixerDataStatus.status !== DeviceStatus.FINISH;
    const { uid, tId, currentDrop, allDrops, truckCode } = mixerDataStatus;
    const mCode = uid ? `${truckCode || tId || uid} ${currentDrop}/${allDrops}` : '';
    const inputDisabled = batchStore.isInputDisabled(device.openTiltStatusPNo) || batchStore.isInputDisabled(device.closeReturnStatusPNo)
      ? 'device-input-disabled' : '';
    const isDisabled = device.diverterPNo ? batchStore.isOutputOn(device.diverterPNo) : false;
    const disabled = isDisabled ? 'disabled' : '';
    let active = '';
    const analogInput = device.analogInputId ? devicesStore.devices.find(v => v.id === device.analogInputId) || {} : {};

    if (!isForwardOff && isReverseOff) {
      active = 'active-forward';
    } else if (isForwardOff && !isReverseOff) {
      active = 'active-reverse';
    } else if (!isForwardOff && !isReverseOff) {
      active = 'device-error';
    }

    const onCountDown = (data) => {
      mixerDataStatus = batchStore.getDeviceStatus(device.id);
      let s = {
        ...mixerDataStatus,
        currentCount: data.seconds,
        restart: false,
      };

      if (mixerDataStatus.status === DeviceStatus.MIXING) {
        if (data.seconds === 0 && device.analogSwitchId) {
          const analogSwitch = devicesStore.devices.find(v => v.id === device.analogSwitchId) || {};
          if (analogSwitch.channelPNo) {
            batchStore.setAnalog(analogSwitch.channelPNo, 10);
          }
        }
        if (!isForwardOutputOff) {
          s.status = DeviceStatus.TOP_OPEN;
          s.delay = device.topOpenTime;
          s.restart = true;
        }
      } else if (mixerDataStatus.status === DeviceStatus.TOP_OPEN) {
        if ((device.automaticMode && data.seconds === 0)
          || (!device.automaticMode && data.seconds >= 0 && batchStore.isMixerFinishAllowed(device) && batchStore.isMixerDischargeAllowed(device) && !!mixerDataStatus.dischargeAllowed)) {
          s.status = DeviceStatus.SWITCHING;
          s.delay = device.switchingDelay || 5;
          s.restart = true;
        }
      } else if (mixerDataStatus.status === DeviceStatus.SWITCHING && data.seconds >= 0 && !mixerDataStatus.restart) {
        s.status = DeviceStatus.CLOSE_DELAY;
        s.delay = device.downCloseDelay;
        s.restart = true;
      } else if (mixerDataStatus.status === DeviceStatus.CLOSE_DELAY && data.seconds >= 0 && !mixerDataStatus.restart) {
        s.status = DeviceStatus.FINISH;
        s.restart = false;
        s.currentCount = 0;
      }

      batchStore.deviceStatus.set(device.id, s);

    };

    const dischargeMixerToggle = e => {
      e.preventDefault();
      mixerDataStatus = batchStore.getDeviceStatus(device.id);

      batchStore.deviceStatus.set(device.id, {
        ...mixerDataStatus,
        dischargeAllowed: !mixerDataStatus.dischargeAllowed,
      });
    };

    const onMouseDown = e => {
      // stop bubbling to prevent unexpected dragging
      e.stopPropagation();
    };

    return (
      <div id={`device-${device.id}`} className={`${disabled} ${active} gate-close device-gui device-gui--forward-reverse-mixer device-${error} ${inputDisabled}`}>
        <Sound file={Sounds.horn} play={mixerDataStatus.restart} />
        {device.analogInputId && (
          <IconUnitLabel value={batchStore.getAnalogInputValue(device.analogInputId)}
            unit={analogInput.unit || AnalogUnitList['%']}
            icon={analogInput.icon || AnalogIconList.DROP}/>
        )}
        <div className="device-label">
          <div className="device-type" title={`#${device.id} ${inputDisabled}`}>
            {inputDisabled ? <i className="fa fa-warning"/> : ''} {name}
          </div>
          <div className="status">{mixerDataStatus.status}</div>
          <div className="device-timer">
            {
              batchStore.replayMode
                ? formatSeconds(mixerDataStatus.currentCount)
                :
                (
                  <Counter delay={mixerDataStatus.delay}
                    currentCount={mixerDataStatus.currentCount}
                    onChange={onCountDown}
                    start={countDownOn}
                    restart={mixerDataStatus.restart}
                  />
                )
            }
          </div>
          {mCode && <div className="mix" title={mCode}>{mCode}</div>}
        </div>
        <div className="device-icon support" />
        <div className="device-icon barrel-wrap">
          <div className="device-icon barrel barrel-1" />
          <div className="device-icon barrel barrel-2" />
          <div className="device-icon barrel barrel-3" />
        </div>
        <div className="device-gui__row">
          {!batchStore.running.length && device.diverterPNo && (
            <div className="toggle-disable">
              <Toggle checked={!isDisabled} onChange={() => {
                batchStore.setOutput(device.diverterPNo, !isDisabled ? OUTPUT_TTL : '0');
              }}/>
            </div>
          )}
          <NormalButton className={`btn-batch btn-batch-green ${!isReverseOutputOff ? 'active' : ''}`}
            port={!isForwardOutputOff ? device.openTiltPNo : device.closeReturnPNo}
            duration={!isReverseOutputOff ? '0' : !isForwardOutputOff ? '0' : OUTPUT_TTL}
            onClick={() => device.automaticMode ? batchStore.rampUpMixer(device.id, isReverseOutputOff && isForwardOutputOff) : void 0}
          >
            <i className="fa fa-reply" />
          </NormalButton>
          <NormalButton className={`btn-batch btn-batch-red ${!isForwardOutputOff ? 'active' : ''}`}
            port={!isReverseOutputOff ? device.closeReturnPNo : device.openTiltPNo}
            duration={!isForwardOutputOff ? '0' : !isReverseOutputOff ? '0' : OUTPUT_TTL}
            onClick={() => device.automaticMode ? batchStore.rampUpMixer(device.id, isReverseOutputOff && isForwardOutputOff) : void 0}
            disabled={batchStore.mixerDownButtonShouldBeDisabled}
          >
            <i className="fa fa-share" />
          </NormalButton>
        </div>

        <Button
          bsSize="sm"
          bsStyle="primary"
          className={`btn-batch btn-batch-red discharge-button ${!!mixerDataStatus.dischargeAllowed ? 'active' : ''}`}
          onMouseDown={onMouseDown}
          onClick={dischargeMixerToggle}
        >
          <i className="fa fa-arrow-down" />
        </Button>
      </div>
    );
  }
}

export default ForwardReverseMixer;
